export default "__VITE_ASSET__d3471a02__"